import React from 'react';
import { AdvancedMarker } from '../map/MapViewWeb';
import { getIconUri } from '../map/MemoizedPantryMarkerUtils';

/**
 * Web-specific marker component for PantryDetails page.
 * Uses AdvancedMarker from @vis.gl/react-google-maps.
 */
function PantryDetailsMarker({ pantry, defaultLocation, icon }) {
  const iconUri = getIconUri(icon);
  const latitude = parseFloat(pantry.latitude) || defaultLocation.latitude;
  const longitude = parseFloat(pantry.longitude) || defaultLocation.longitude;

  return (
    <AdvancedMarker position={{ lat: latitude, lng: longitude }} title={pantry.name}>
      <img src={iconUri} style={{ width: 28, height: 'auto' }} alt={pantry.name} />
    </AdvancedMarker>
  );
}

export default PantryDetailsMarker;
